export default () => (
	<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clip-path="url(#ff9qgftaxa)">
			<path
				d="M8.75 18.75h8.75v2.5H8.75v-2.5zm0-5h12.5v2.5H8.75v-2.5zm0-5h12.5v2.5H8.75v-2.5zm15-5h-5.225C18 2.3 16.625 1.25 15 1.25s-3 1.05-3.525 2.5H6.25a2.19 2.19 0 0 0-.5.05c-.487.1-.925.35-1.263.688-.224.224-.412.5-.537.8-.125.287-.2.612-.2.962v17.5c0 .337.075.675.2.975.125.3.313.563.537.8a2.51 2.51 0 0 0 1.263.688c.162.024.325.037.5.037h17.5c1.375 0 2.5-1.125 2.5-2.5V6.25c0-1.375-1.125-2.5-2.5-2.5zM15 3.437c.512 0 .938.425.938.938a.944.944 0 0 1-.938.938.944.944 0 0 1-.938-.938c0-.513.426-.938.938-.938zm8.75 20.313H6.25V6.25h17.5v17.5z"
				fill="#7EA6B4"
			/>
		</g>
		<circle cx="25" cy="25" r="7" fill="#7EA6B4" />
		<path d="M24 21v5l3 2" stroke="#fff" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
		<defs>
			<clipPath id="ff9qgftaxa">
				<path fill="#fff" d="M0 0h30v30H0z" />
			</clipPath>
		</defs>
	</svg>
);
